import { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingDialog from './LandingDialog';

function LandingPlanHelpDialog({ open, onClose }) {
    const { getLangPath } = useLangContext();
    const close = useCallback(() => onClose(), [onClose]);

    return (
        <LandingDialog
            id="plan-help-dialog"
            open={open}
            onClose={close}
            className="dialog plan-help-dialog"
            labelledBy="plan-help-title"
        >
            <h3 id="plan-help-title">{getLangPath('landing.plans.terms')}</h3>
            <div className="plan-help-copy">
                <div className="term-row">
                    <strong>FTD</strong>
                    <p>{getLangPath('landing.planHelp.ftdText')}</p>
                </div>
                <div className="term-row">
                    <strong>QFTD</strong>
                    <p>{getLangPath('landing.planHelp.qftdText')}</p>
                </div>
                <div className="term-row">
                    <strong>{getLangPath('landing.planHelp.lot')}</strong>
                    <p>{getLangPath('landing.planHelp.lotText')}</p>
                </div>
                <div className="term-row">
                    <strong>{getLangPath('landing.planHelp.rebate')}</strong>
                    <p>{getLangPath('landing.planHelp.rebateText')}</p>
                </div>
            </div>
            <button className="btn" id="close-plan-help" type="button" onClick={close}>
                {getLangPath('landing.incomeHelp.close')}
            </button>
        </LandingDialog>
    );
}

export default LandingPlanHelpDialog;
